/**
 * AccordionGroup - 管理手风琴组件的互斥行为
 * 当一个手风琴打开时，会自动关闭同组中的其他手风琴
 */
class AccordionGroup extends HTMLElement {
  constructor() {
    super();
    this.accordions = [];
    this.activeAccordion = null;
    this.mutationObserver = new MutationObserver(this.handleMutations.bind(this));
  }

  connectedCallback() {
    // 观察子元素变化
    this.mutationObserver.observe(this, { childList: true, subtree: true });
    
    // 初始化现有的手风琴元素
    this.initAccordions();
  }

  disconnectedCallback() {
    this.mutationObserver.disconnect();
    this.removeAllEventListeners();
  }

  initAccordions() {
    // 查找所有accordion-disclosure元素
    const accordions = this.querySelectorAll('details[is="accordion-disclosure"]');
    
    accordions.forEach(accordion => {
      if (!this.accordions.includes(accordion)) {
        this.accordions.push(accordion);
        accordion.addEventListener('toggle', this.handleAccordionToggle.bind(this, accordion));
        
        // 如果有默认打开的手风琴，记录它
        if (accordion.open) {
          this.activeAccordion = accordion;
        }
      }
    });
  }

  handleMutations(mutations) {
    let needsInit = false;
    
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        needsInit = true;
      }
    });
    
    if (needsInit) {
      this.initAccordions();
    }
  }

  handleAccordionToggle(accordion) {
    if (accordion.open) {
      // 关闭其他所有手风琴
      this.accordions.forEach(otherAccordion => {
        if (otherAccordion !== accordion && otherAccordion.open) {
          otherAccordion.open = false;
        }
      });
      
      this.activeAccordion = accordion;
    } else if (this.activeAccordion === accordion) {
      this.activeAccordion = null;
    }
  }

  removeAllEventListeners() {
    this.accordions.forEach(accordion => {
      accordion.removeEventListener('toggle', this.handleAccordionToggle);
    });
    this.accordions = [];
  }
}

// 注册自定义元素
if (!window.customElements.get('accordion-group')) {
  window.customElements.define('accordion-group', AccordionGroup);
}